"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiValidateLoginSuccessResponse = instanceOfApiValidateLoginSuccessResponse;
exports.ApiValidateLoginSuccessResponseFromJSON = ApiValidateLoginSuccessResponseFromJSON;
exports.ApiValidateLoginSuccessResponseFromJSONTyped = ApiValidateLoginSuccessResponseFromJSONTyped;
exports.ApiValidateLoginSuccessResponseToJSON = ApiValidateLoginSuccessResponseToJSON;
exports.ApiValidateLoginSuccessResponseToJSONTyped = ApiValidateLoginSuccessResponseToJSONTyped;
/**
 * Check if a given object implements the ApiValidateLoginSuccessResponse interface.
 */
function instanceOfApiValidateLoginSuccessResponse(value) {
    if (!('success' in value) || value['success'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ApiValidateLoginSuccessResponseFromJSON(json) {
    return ApiValidateLoginSuccessResponseFromJSONTyped(json, false);
}
function ApiValidateLoginSuccessResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'success': json['success'],
        'message': json['message'],
    };
}
function ApiValidateLoginSuccessResponseToJSON(json) {
    return ApiValidateLoginSuccessResponseToJSONTyped(json, false);
}
function ApiValidateLoginSuccessResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'success': value['success'],
        'message': value['message'],
    };
}
